import React, { Fragment, useEffect, useState } from 'react'
import DashboardHeader from '../Common/DashboardHeader'
import EmailInput from '../reusableComponents/EmailInput'
import FilterEmailInput from '../reusableComponents/FilterEmailInput'
import { useSelector } from 'react-redux'
import CustomerInput from '../reusableComponents/CustomerInput'
import { Transition } from '@headlessui/react'

const KYCComparison = () => {

    const [activeTab, setActiveTab] = useState(1);

    const v2pRMData = useSelector((state) => state.v2pRMData.V2PRMData);

    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        // Add a class to the body when the modal is open
        if (isModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            // Remove the class when the modal is closed
            document.body.style.overflow = 'auto';
        }

        // Clean up the effect on component unmount
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isModalOpen]); // Run the effect whenever isModalOpen changes



    const handleTabClick = (tabNumber) => {
        setActiveTab(tabNumber);
    }

    // Dummy data for testing
    const displayedData1 = [
        {
            customerName: 'Customer 1',
            email: 'customer1@example.com',
            phone: '1234567890',
            partnerBankName: 'Bank 1',
            program: 'Program 1',
            isSubmitedAt: '2022-01-01',
        },
        {
            customerName: 'Customer 2',
            email: 'customer2@example.com',
            phone: '9876543210',
            partnerBankName: 'Bank 2',
            program: 'Program 2',
            isSubmitedAt: '2022-02-01',
        },
        // Add more data objects as needed
    ];
    return (
        <body className='mailsentbody'>
            <div >
                <div className="rightElement">
                    <DashboardHeader />
                    <div className="grid mt-6 grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
                        <div className="col-span-12 md:col-span-10 lg:col-span-10 ">
                            <div className="mt-2 p-2">
                                <div className="col-span-12">
                                    <h1 className="text-4xl text-left font-medium ">KYC Comparison</h1>
                                </div>
                            </div>
                            <div className='bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg'>
                                <div className="flex">
                                    <div
                                        onClick={() => handleTabClick(1)}
                                        className={`cursor-pointer text-center w-full px-4 py-2 border-b-2 ${activeTab === 1 ? 'border-sky-700 text-black font-bold text-lg' : 'text-black font-bold text-lg hover:border-sky-700'
                                            }`}
                                    >
                                        CUSTOMER
                                    </div>
                                    <div
                                        onClick={() => handleTabClick(2)}
                                        className={`cursor-pointer text-center w-full px-4 py-2 border-b-2 ${activeTab === 2 ? 'border-sky-700 text-black font-bold text-lg' : 'text-black font-bold text-lg hover:border-sky-700'
                                            }`}
                                    >
                                        VENDOR
                                    </div>
                                </div>
                                <div className='p-2'>
                                    <div className='p-2'>
                                        {activeTab === 1 && <>
                                            <div className="grid mt-5 grid-cols-12 gap-4 mb-5">
                                                <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3">
                                                    <label for="email" className="block text-md font-medium leading-6 text-gray-900">Customer</label>
                                                    <CustomerInput inputStyles={{ padding: '12px' }} />
                                                </div>
                                                <div className="col-span-12 md:col-span-6 lg:col-span-6 ">
                                                    <div className="flex mt-5">
                                                        <div className="vtpRm-action-button">Filter list</div>
                                                        <div className="vtpRm-back-button">Clear Filter</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="overflow-x-auto mt-2 border rounded-md shadow-sm shadow-sm">
                                                <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                                                    <thead className="bg-white-400">
                                                        <tr>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                Sr. No.
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                Customer ID
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                Customer Name
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                GSTIN
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                PAN
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider">
                                                                Action
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="bg-white divide-y divide-gray-200">
                                                        {displayedData1?.map((item, index) => (
                                                            <tr key={index} className="border-t">
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{index + 1}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.customerName}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.email}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.phone}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.partnerBankName}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap ">
                                                                    <button
                                                                        onClick={() => setIsModalOpen(true)}
                                                                        className="px-2 py-1 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white mr-2"
                                                                    >
                                                                        Compare
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>}
                                        {activeTab === 2 && <>
                                            <div className="grid mt-5 grid-cols-12 gap-4 mb-5">
                                                <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3">
                                                    <label for="email" className="block text-md font-medium leading-6 text-gray-900">Customer</label>
                                                    <CustomerInput inputStyles={{ padding: '12px' }} />
                                                </div>
                                                <div className="col-span-12 md:col-span-6 lg:col-span-6 ">
                                                    <div className="flex mt-5">
                                                        <div className="vtpRm-action-button">Filter list</div>
                                                        <div className="vtpRm-back-button">Clear Filter</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="overflow-x-auto mt-2 border rounded-md shadow-sm shadow-sm">
                                                <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                                                    <thead className="bg-white-400">
                                                        <tr>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                Sr. No.
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                Vendor ID
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                Vendor Name
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                GSTIN
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                                PAN
                                                            </th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider">
                                                                Action
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="bg-white divide-y divide-gray-200">
                                                        {displayedData1?.map((item, index) => (
                                                            <tr key={index} className="border-t">
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{index + 1}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.customerName}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.email}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.phone}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.partnerBankName}</td>
                                                                <td className="px-6 py-1 whitespace-nowrap ">
                                                                    <button
                                                                        className="px-2 py-1 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white mr-2"
                                                                    >
                                                                        Download
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>}
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        show={isModalOpen}
                                        enter="ease-out duration-300"
                                        enterFrom="opacity-0"
                                        enterTo="opacity-100"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100"
                                        leaveTo="opacity-0"
                                    >
                                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
                                            <div className="fixed inset-0 z-10 overflow-y-auto">
                                                <div className="flex items-center justify-center min-h-full p-4 sm:p-0">
                                                    <Transition
                                                        as={Fragment}
                                                        enter="ease-out duration-300"
                                                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                                                        leave="ease-in duration-200"
                                                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                    >
                                                        <div className="relative transform overflow-hidden rounded-lg text-left transition-all w-full max-w-2xl sm:max-w-3xl h-auto">
                                                            <form
                                                            //    onSubmit={OnBoardNewCustomer}
                                                            >
                                                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                                                    <div className="sm:flex sm:items-start">
                                                                        <div className=" w-full sm:text-left">
                                                                            <h3 className="text-base font-semibold leading-6 text-center text-gray-900" id="modal-title">BRISLOY METALS INDIA PVT LTD</h3>
                                                                            <div className="mt-2 border-t">
                                                                                <div className="grid mt-4 grid-cols-12 gap-2">
                                                                                    <div className='col-span-12 sm:col-12 md:col-span-12 text-center'>
                                                                                        GSTIN : 06AAGCB8189C2ZK  |  PAN : AAGCB8189C  |  CIN :
                                                                                    </div>
                                                                                    <div className='col-span-12 sm:col-4 md:col-span-4'>
                                                                                        V2P Portal Data
                                                                                    </div>
                                                                                    <div className='col-span-12 sm:col-4 md:col-span-4'>
                                                                                        STIN Data
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                                                    <button type="submit" className="inline-flex w-full justify-center rounded-md bg-sky-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-700 sm:ml-3 sm:w-auto">Proceed</button>
                                                                    <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={() => setIsModalOpen(false)}>Cancel</button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </Transition>
                                                </div>
                                            </div>
                                        </div>
                                    </Transition>

                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
                    </div>
                </div>
            </div >
        </body >
    )
}

export default KYCComparison
